// generated by genversion
const version = '6.14.3';

export { version };
//# sourceMappingURL=version.mjs.map
